import { borderBottom } from "@material-ui/system";

/* Response Time CSS */

export default theme => ({
    rootClassName:{
        width:"100%"
    },
    circular:{
      color:"white",
    },
    print: {
        border:"1px solid"    
        },
    alignRight:{
      textAlign:"right"
    },
    width50:{
      width:"50%"
    },
    backWhite:{
      backgroundColor:"white",
      color:"#FF4500"
    },
    buttonPeriodical: {
      // backgroundColor:"#f77520",
      // color:"white"
      boxShadow:"inset 0px 1px 0px 0px #fce2c1",
      background:"linear-gradient(to bottom, #ffc477 5%, #fb9e25 100%)",
      backgroundColor:"#ffc477",
      borderRadius:"6px",
      border:"1px solid #eeb44f",
      display:"inline-block",
      cursor:"pointer",
      color:"#ffffff",
      fontFamily:"Arial",
      fontSize:"15px",
      fontWeight:"bold",
      padding:"6px 24px",
      textDecoration:"none",
      textShadow:"0px 1px 0px #cc9f52"
    },
    label: {
      color: "white",
      padding: "8px",
      fontFamily: "Arial",
      backgroundColor:" #ffc477",
      border:"1px solid #eeb44f",
    }

    
});

